module.exports = __webpack_public_path__ + "static/img/12.c4405e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/4/zh/12.png
// module id = Ocyw
// module chunks = 0